
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M262.4 678.4l-166.4 166.4 83.2 83.2 166.4-166.4L512 928V512H96zM928 179.2l-83.2-83.2-166.4 166.4L512 96V512h416l-166.4-166.4z"
      }
    }
  ]
})
    }
  